"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getViewport = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _input = _interopRequireDefault(require("../input"));

var _optionList = _interopRequireDefault(require("./option-list"));

var _inputModule = _interopRequireDefault(require("../input/input.module.scss"));

var _dropdownModule = _interopRequireDefault(require("./dropdown.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var getViewport = function getViewport() {
  return {
    height: window.innerHeight || document.documentElement.offsetHeight,
    width: window.innerWidth || document.documentElement.offsetWidth,
    scrollX: window.scrollX,
    scrollY: window.scrollY
  };
};

exports.getViewport = getViewport;

var Dropdown = function Dropdown(_ref) {
  var _cx;

  var className = _ref.className,
      inputClassName = _ref.inputClassName,
      inputElementClassName = _ref.inputElementClassName,
      optionClassName = _ref.optionClassName,
      source = _ref.source,
      value = _ref.value,
      label = _ref.label,
      hideLabel = _ref.hideLabel,
      disabled = _ref.disabled,
      error = _ref.error,
      optionRenderer = _ref.optionRenderer,
      onFocus = _ref.onFocus,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      allowCustomValue = _ref.allowCustomValue;

  /** indicate if option list is shown */
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showOptions = _useState2[0],
      setShowOptions = _useState2[1];
  /** track typed text when allowCustomValue is enabled */


  var _useState3 = (0, _react.useState)(function () {
    var opt = source.find(function (o) {
      return o.value === value;
    });
    return (opt === null || opt === void 0 ? void 0 : opt.label) || '';
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      inputQuery = _useState4[0],
      setInputQuery = _useState4[1];
  /** prevent blur from emitting custom value right after an option was selected */


  var skipNextBlurEmit = (0, _react.useRef)(false);
  /** sync inputQuery when value prop changes externally */

  var _useState5 = (0, _react.useState)(value),
      _useState6 = _slicedToArray(_useState5, 2),
      prevValue = _useState6[0],
      setPrevValue = _useState6[1];

  if (value !== prevValue) {
    setPrevValue(value);
    var opt = source.find(function (o) {
      return o.value === value;
    });
    setInputQuery((opt === null || opt === void 0 ? void 0 : opt.label) || (allowCustomValue ? String(value !== null && value !== void 0 ? value : '') : ''));
  }
  /** handle focus and calculate position for suggestion list  */


  var _useState7 = (0, _react.useState)({}),
      _useState8 = _slicedToArray(_useState7, 2),
      listStyle = _useState8[0],
      setListStyle = _useState8[1];

  var inputElement = (0, _react.useRef)();
  var handleFocus = (0, _react.useCallback)(function () {
    if (disabled) {
      return;
    }

    if (inputElement.current) {
      var _getViewport = getViewport(),
          scrollY = _getViewport.scrollY,
          scrollX = _getViewport.scrollX;

      var _inputElement$current = inputElement.current.getBoundingClientRect(),
          inputX = _inputElement$current.left,
          inputY = _inputElement$current.top,
          inputHeight = _inputElement$current.height,
          inputWidth = _inputElement$current.width;

      var left = inputX + scrollX;
      var top = inputY + inputHeight + scrollY; // max height of list should either be 45% of the viewport or the space to the window border - 30px for spacing

      var spaceToWindowEnd = window.innerHeight - (inputY + inputHeight);
      var viewportMaxHeight = window.innerHeight * 0.45;
      setListStyle({
        top: top,
        left: left,
        width: inputWidth,
        maxHeight: Math.min(spaceToWindowEnd - 30, viewportMaxHeight)
      });
    }

    setShowOptions(true);
    onFocus();
  }, [disabled, onFocus]);
  /** handle blur */

  var handleBlur = (0, _react.useCallback)(function () {
    if (disabled) {
      return;
    }

    setShowOptions(false);

    if (allowCustomValue) {
      if (!skipNextBlurEmit.current) {
        onChange(inputQuery);
      }

      skipNextBlurEmit.current = false;
    }

    onBlur();
  }, [disabled, onBlur, allowCustomValue, inputQuery, onChange]);
  /** handle selection of value */

  var handleSelect = (0, _react.useCallback)(function (newValue) {
    if (allowCustomValue) {
      var _opt = source.find(function (o) {
        return o.value === newValue;
      });

      setInputQuery((_opt === null || _opt === void 0 ? void 0 : _opt.label) || '');
      skipNextBlurEmit.current = true;
      onChange(newValue); // Do not call handleBlur here — the real input blur event will fire and close the list
    } else {
      onChange(newValue);
      handleBlur();
    }
  }, [allowCustomValue, source, onChange, handleBlur]); // hide the options if the input position has changed after scrolling

  var handleScroll = (0, _react.useCallback)(function () {
    if (inputElement.current && showOptions) {
      var _getViewport2 = getViewport(),
          scrollY = _getViewport2.scrollY,
          scrollX = _getViewport2.scrollX;

      var _inputElement$current2 = inputElement.current.getBoundingClientRect(),
          inputX = _inputElement$current2.left,
          inputY = _inputElement$current2.top,
          inputHeight = _inputElement$current2.height,
          inputWidth = _inputElement$current2.width;

      var left = inputX + scrollX;
      var top = inputY + inputHeight + scrollY;

      if (top !== listStyle.top || left !== listStyle.left || inputWidth !== listStyle.width) {
        inputElement.current.blur();
      }
    }
  }, [listStyle.left, listStyle.top, listStyle.width, showOptions]); // add and remove scroll event listener

  (0, _react.useEffect)(function () {
    document.addEventListener('scroll', handleScroll, true);
    return function () {
      document.removeEventListener('scroll', handleScroll, true);
    };
  }, [handleScroll]);
  var selectedOption = (0, _react.useMemo)(function () {
    return source.find(function (option) {
      return option.value === value;
    });
  }, [source, value]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_dropdownModule["default"].dropdown, className)
  }, selectedOption && optionRenderer ? /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_inputModule["default"].input, (_cx = {}, _defineProperty(_cx, _inputModule["default"].hasError, !!error), _defineProperty(_cx, _inputModule["default"].isDisabled, disabled), _cx), _dropdownModule["default"].inputElement, inputClassName),
    role: "textbox",
    tabIndex: "0",
    onFocus: handleFocus,
    onBlur: handleBlur
  }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("div", {
    ref: inputElement,
    className: (0, _classnames["default"])(_inputModule["default"].inputElement, _defineProperty({}, _inputModule["default"].filled, value), inputElementClassName)
  }, optionRenderer({
    option: selectedOption,
    isSelectedOption: true
  })), label ? /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])(_inputModule["default"].label, {
      'sr-only': hideLabel
    })
  }, label) : null), error ? /*#__PURE__*/_react["default"].createElement("span", {
    className: _inputModule["default"].error
  }, error) : null) : /*#__PURE__*/_react["default"].createElement(_input["default"], {
    ref: inputElement,
    className: (0, _classnames["default"])(_dropdownModule["default"].inputElement, inputClassName),
    inputClassName: (0, _classnames["default"])(_dropdownModule["default"].innerInputElement, inputElementClassName),
    disabled: disabled,
    value: allowCustomValue ? inputQuery : selectedOption && selectedOption.label,
    label: label,
    hideLabel: hideLabel,
    error: error,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onChange: allowCustomValue ? function (newQuery) {
      return setInputQuery(newQuery);
    } : undefined
  }), showOptions && /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement(_optionList["default"], {
    style: listStyle,
    options: source,
    value: selectedOption && selectedOption.value,
    optionRenderer: optionRenderer,
    optionClassName: optionClassName,
    onChange: handleSelect
  }), document.body));
};

Dropdown.propTypes = {
  className: _propTypes["default"].string,
  inputClassName: _input["default"].propTypes.className,
  inputElementClassName: _input["default"].propTypes.inputClassName,
  optionClassName: _propTypes["default"].string,
  source: _optionList["default"].propTypes.options,
  error: _input["default"].propTypes.error,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  label: _propTypes["default"].node,
  hideLabel: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  optionRenderer: _propTypes["default"].func,
  allowCustomValue: _propTypes["default"].bool
};

var noop = function noop() {};

Dropdown.defaultProps = {
  error: _input["default"].defaultProps.error,
  className: '',
  inputClassName: _input["default"].defaultProps.className,
  inputElementClassName: _input["default"].defaultProps.inputClassName,
  optionClassName: '',
  source: [],
  value: '',
  label: '',
  hideLabel: false,
  disabled: false,
  onChange: noop,
  onFocus: noop,
  onBlur: noop,
  optionRenderer: undefined,
  allowCustomValue: false
};
var _default = Dropdown;
exports["default"] = _default;